import React, { Component } from 'react'
import BroadcastSchedule from '../../containers/LiveTV/BroadcastSchedule'
import moment from 'moment'

class BroadcastScheduleControl extends Component {

    constructor(props) {
        super(props);
        this.state = {
            channel: this.props.channel,
            schedule_id: this.props.schedule_id,
            date: moment().format("YYYY-MM-DD")
        }
    }

    componentWillReceiveProps(nextProps) {
        const channels = nextProps.channels.channels

        const channel = channels.find(channel => channel.slug === nextProps.channel)
        this.setState({
            channel: nextProps.channel,
            schedule_id: channel.schedule_id,
            date: moment().format("YYYY-MM-DD")
        })
    }

    onSelectChannel = (event) => {
        const channels = this.props.channels.channels

        const channel = channels.find(channel => channel.slug === event.target.value)
        this.setState({
            channel: event.target.value,
            schedule_id: channel.schedule_id
        });
    };

    onSelectDate = (event) => {
        this.setState({
            date: event.target.value
        });
    };

    render() {
        if (this.props.channels.loading) return 'Loading...';
        if (this.props.channels.error) return 'Fetch data error';

        const channels = this.props.channels.channels;
        const channelsElement = channels.map(channel => (
                <option key={channel.slug} value={channel.slug}>{channel.name}</option>
            )
        );

        return (
            <div className="tv-detail">
                <div className="top">
                    <div className="pull-left">
                        <div className="name">Lịch phát sóng</div>
                    </div>
                    <div className="pull-right">
                        <select value={this.state.channel} onChange={this.onSelectChannel} className="select1">
                            {channelsElement}
                        </select>
                        <select onChange={this.onSelectDate} className="select2">
                            <option value={moment().format("YYYY-MM-DD")}>Hôm nay</option>
                            <option value={moment().add(1, "day").format("YYYY-MM-DD")}>Ngày mai</option>
                            <option value={moment().add(2, "day").format("YYYY-MM-DD")}>Ngày kia</option>
                        </select>
                    </div>
                </div>
                <BroadcastSchedule channel_id={this.state.schedule_id} date={this.state.date}/>
            </div>
        );
    }
}

export default BroadcastScheduleControl



// WEBPACK FOOTER //
// ./src/components/LiveTV/BroadcastScheduleControl.js